// extracted by mini-css-extract-plugin
export default {"menuContainer":"styles_menuContainer__SVHSV","headerContainer":"styles_headerContainer__IiWFu","footer":"styles_footer__ZPvM0","listContent":"styles_listContent__I9lJq"};